export default "__VITE_ASSET__d325746d__"